import {Suspense} from 'react';
import {NavLink, Outlet, useLocation} from 'react-router-dom';
import {isMobile} from "react-device-detect";
import {Helmet} from "react-helmet";
import WebPaths from "@router/paths/web";
import DETAILS from "@constants/shopDetails";
import details from "@constants/shopDetails";
import Copyright from "../web/components/footers/Footer1/components/copyright";
import logoImage from "@assets/images/logo/logo.webp";
import "./style.scss";

const BlankLayout = () => {
    const location = useLocation();
    const {name} = DETAILS;

    return (
        <div
            className={`blank-layout${(isMobile && (location.pathname.includes("/shipping") || location.pathname.includes("/payment"))) ? ' bottom-space' : ''}`}>
            <Suspense fallback={null}>
                <header>
                    <div className="d-flex justify-content-center">
                        <NavLink to={WebPaths.home}>
                            <img src={logoImage} alt={name} width="120px"/>
                        </NavLink>
                    </div>
                </header>

                <main className="blank-layout-content">
                    <Helmet>
                        <title>{details.name}</title>
                    </Helmet>

                    <Outlet/>
                </main>

                <footer>
                    <Copyright/>
                </footer>
            </Suspense>
        </div>
    );
};

export default BlankLayout;
